module.exports={"wireguard adapter settings":"Configurações do adaptador para wireguard",option1:"Opção 1",option2:"opção 2"};